import BaseObject from "./BaseObject";
import NP from "./NP";
import {Role} from "./Types";
import {PageMode} from "../10. Battle/types";

let numeral = require('numeral');
let moment = require('moment');


export interface IUserInfo {
	Id: number,
	Email: string,
	FirstName: string
	LastName: string,
	NCP: boolean,
	Role: Role,
	UILang: string,
	Features: string[],
	FCMToken: string
	gymRating: number,
}

export interface AppSettings {
	CountryFlagFolder: string
}

export default class UserInfo extends BaseObject {


	private _FirstName: string;
	private _LastName: string;
	private _Email: string;
	private _NCP: boolean;
	private _UILang: string;
	private _Role: Role;
	private _AppSettings: AppSettings;
	private _Features: PageMode[];


	constructor(settings: IUserInfo)
	{
		super(settings);
	}

	_initFields(settings: IUserInfo)
	{
		this._Features = null;
		this._AppSettings = null;
		this._FirstName = null;
		this._LastName = null;
		this._Email = null;
		this._NCP = null;
		this._Role = null;
		this._UILang = 'en';
		super._initFields(settings);
		if (!this._Features)
			this._Features = [];
	}

	getAppSettings()
	{
		return this._AppSettings;
	}


	getFeatures()
	{
		return this._Features;
	}

	getIsAdmin()
	{
		return this._Role == Role.admin;
	}


	getFirstName()
	{
		return this._FirstName;
	}


	getLastName()
	{
		return this._LastName;
	}


	getEmail()
	{
		return this._Email;
	}

	getUILang()
	{
		return this._UILang;
	}

	getKey()
	{
		return this._Id;
	}


	getBanner(): string
	{
		return null;
	}


	getViewName()
	{
		let res = "";
		if (this._FirstName)
			res = this._FirstName;

		if (this._LastName)
		{
			if (res)
				res += ' ';
			res += this._LastName;
		}
		return res ? res : this._Email;
	}

	static getViewName(info: IUserInfo)
	{
		if (info.FirstName || info.LastName)
			return (info.FirstName || "") + ' ' + (info.LastName || "");
		else
			return info.Email;
	}


	getLogin()
	{
		return this._Email;
	}

	isJudge()
	{
		return this._Role == Role.Judge
	}

	isBDAdmin()
	{
		return this._Role == Role.admin
	}


	isFantasyAvailable()
	{
		return this.isBDAdmin();
	}

	getRegionalSettings()
	{
		return {};
	}
}

NP.processAuthCheckResponse = function ()
{
	if (NP._CurrentUser)
		NP._CurrentUser.destroy();
	NP._CurrentUser = new UserInfo((window as any).currentUser);
	NP.applyRegionalFormat();
};

NP.applyRegionalFormat = function ()
{
	let culture = NP.getCurrentCulture();
	if (!culture)
		return;

	let regInfo = NP._CurrentUser.getRegionalSettings(),
		 is12H = regInfo.Is24HFormat == false,
		 delimiters = {
			 decimal: regInfo.DecimalSeparator || culture.DecimalSeparator,
			 thousands: regInfo.ThousandsSeparator || culture.GroupSeparator
		 };

	try
	{
		numeral.register('locale', culture.Name, {
			delimiters: delimiters,
			currency: {symbol: "$"}
		});
	} catch
		 (e)
	{
	}

	moment.updateLocale(culture.Name,
		 {
			 longDateFormat: {
				 LT: !is12H ? 'HH:mm' : 'hh:mm A',
				 LTS: !is12H ? 'HH:mm:ss' : 'hh:mm:ss A'
			 },
			 week: {
				 dow: regInfo.FirstDayOfWeek
			 }
		 });
};

export function getCurrentUser(): UserInfo
{
	return NP._CurrentUser;
}

NP.getCurrentUser = function (): UserInfo
{
	return NP._CurrentUser;
};

NP.isAdmin = function ()
{
	return NP._CurrentUser && NP._CurrentUser.getIsAdmin();
};


NP._CurrentUser = new UserInfo({Id: -1} as IUserInfo);

NP.isAuthorized = function ()
{
	return NP._CurrentUser.getKey() > 0;
};

export function signOut()
{
	setTimeout(function ()
	{
		window.location.href = "/login-actions/logout";
	}, 500);
}
